<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-row>
        <v-col>
          <CommonTable :keyword="keyword" />
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import CommonTable from '../components/CommonTable.vue'
import TitleComponent from '../components/TitleComponent.vue';

export default {
  components: { CommonTable, TitleComponent },
  data() {
    return {
      keyword: 'incorrect',
    }
  },
};
</script>